import { Flex, Input, Span, Button, Label, Grid } from '@fareye/ui'
import { cloneDeep, getValueFromNestedKey } from '@fareye/utils'
import React from 'react'
import { formatters } from '../../../config/constants'
import { ColFullHeight } from '../../../style/styled'
import { IColumnConfig } from '../../../utility/types'
import DeletePoi from './DeletePoi'

function generateColumnObject(column: IColumnConfig, propsConfig: any) {
  //TODO: Add Tracking column
  let { label, key, formatter} = column

  const { t, setSelectedPoi } = propsConfig
  switch (key) {
    case 'action':
      return {
        Header: <Label style={{padding:"10px"}} color="black">{t(label)}</Label>,
        id: key,
        width: 60,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="referenceNo|slug">
            <Grid gridTemplateColumns="repeat(2,1fr)" gridGap={'5px'}>
              <Button
                onClick={() =>{
                  let poiConfig=cloneDeep(original)
                  if(poiConfig.Type){
                      poiConfig.Type={
                        label:poiConfig.Type,
                        value:poiConfig.Type,
                      }
                  }if(poiConfig.poiType){
                    poiConfig.poiType={
                      label:poiConfig.poiType,
                      value:poiConfig.poiType,
                    }
                  }
                  if(poiConfig.identifier){
                    poiConfig.identifier={
                      label:poiConfig.identifier,
                      value:poiConfig.identifier,
                    }
                  }
                  if(poiConfig.latLngList){
                    poiConfig.latLngList=poiConfig.latLngList.join(":")
                  }
                  setSelectedPoi({
                    data: poiConfig,
                    action: "edit",
                    openModal: true
                  })}
                }
                variant="s primary"
              >
                Edit
              </Button>
              <DeletePoi
                selectedPoi={original}
              />
            </Grid>
          </ColFullHeight>
        )
      }

    default:
      return {
        Header: <Label style={{padding:"10px"}} color="black">{t(label)}</Label>,
        id: key,
        width: 50,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => {
          let value = getValueFromNestedKey(original, key)
          return (
            <ColFullHeight data-testid={key}>
              <Span fontSize={14} variant="ellipsis">
                {formatter && formatters[formatter]
                  ? formatters[formatter](value) || '-'
                  : value ?? '-'}
              </Span>
            </ColFullHeight>
          )
        }
      }
  }
}
export function getTableColumns(
  reqdColumns: IColumnConfig[],
  propsConfig?: any
) {
  const COLUMNS = reqdColumns.map(ele => generateColumnObject(ele, propsConfig))

  //const result = COLUMNS.filter(column => reqdColumns.includes(column.id))
  return COLUMNS
}
